import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames/dedupe';
import getScrollTop from '../../util/getScrollTop';
import pubSub from '../../util/pubSub';

const mapStateToProps = state =>({
  displayAdCount: state.ads.displayAdUpdate.displayAdCount,
  windowWidth: state.events.windowSize.width,
});

@connect(mapStateToProps)
export default class Sticky extends React.PureComponent {
  componentDidMount() {
    this.calculateSizeAndPosition(this.props.offset);
    this.handler(getScrollTop());
    this.scrollSubscription = pubSub.subscribe('scroll', (scrollTop) => this.handler(scrollTop));
  }

  componentWillReceiveProps({ displayAdCount, offset, windowWidth }) {
    if (displayAdCount !== this.props.displayAdCount
      || offset !== this.props.offset
      || windowWidth !== this.props.windowWidth) {
      this.calculateSizeAndPosition(offset);
    }
  }

  componentWillUnmount() {
    this.scrollSubscription.remove();
  }

  calculateSizeAndPosition(offset) {
    this.element = this.refs.stickyWrapper.childNodes[0];
    this.elementHeight = this.element.clientHeight;
    this.elementOffset = this.refs.stickyWrapper.getBoundingClientRect().top + getScrollTop() + (offset || 0);
    if (this.props.fixedWidth && this.element.clientWidth) this.element.style.width = `${this.element.clientWidth}px`;
    this.forceUpdate();
  }

  handler(scrollTop) {
    const isSticky = scrollTop >= this.elementOffset && (!this.props.fixedWidth || this.element.clientWidth);
    this.element.className = cx(this.element.className, { 'is-sticky': isSticky });
  }

  render() {
    return (
      <div ref="stickyWrapper" style={{ height: this.elementHeight }}>
        {this.props.children}
      </div>
    );
  }
}

Sticky.propTypes = {
  offset: React.PropTypes.number,
  windowWidth: React.PropTypes.number,
  children: React.PropTypes.object,
  displayAdCount: React.PropTypes.number,
  fixedWidth: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/Page/Sticky.jsx